<template>
  <div class="corporation_edit">
    <div
      v-for="headerTitle in headerTitles"
      :key="headerTitle.value"
      class="title_header"
      :style="{backgroundColor: headerTitle.color}"
    >
      <div
        class="title_header_value vertical_align_div"
        @click="pageLink(headerTitle.path)"
      >
        <span class="header_router">
          {{ headerTitle.value }}
        </span>
      </div>
    </div>
    <div class="corporation_contents">
      <div class="corporation_contents_background">
        <div class="corporation_edit_area_title">
          {{ contractEditInfoTitle }}
        </div>
        <contractEditInfo></contractEditInfo>
        <div class="corporation_edit_area_title">{{ tenantEditInfoTitle }}</div>
        <tenantEditInfo
          @clickPasswordChangeButton="showChangePasswordModal = true"
        >
        </tenantEditInfo>
        <div class="corporation_edit_area_title">
          {{ tenantOptionEditInfoTitle }}
        </div>
        <tenantOptionEditInfo></tenantOptionEditInfo>
      </div>
      <div class="corporation_edit_bottom">
        <div class="corporation_edit_bottom_buttons">
          <input
            type="button"
            :value="deleteButton"
            class="common_delete_button"
            @click="showDeleteConfirmModal = true"
          />
          <input
            type="button"
            :value="cancelButton"
            class="cancel_button"
            @click="cancel"
          />
          <input
            type="button"
            :value="addButton"
            class="finish_button"
            @click="updateCorporation"
          />
        </div>
      </div>
      <div class="complete_modal_window" v-if="showCompleteModal">
        <completeModalWindow :question="completeWord" @close="close">
        </completeModalWindow>
      </div>
      <div class="complete_modal_window" v-if="showFailureModal">
        <completeModalWindow :question="failureWord" @close="stayClose">
        </completeModalWindow>
      </div>
      <div class="loading_modal_window" v-if="showloadingModal">
        <loadingModalWindow @close="close"> </loadingModalWindow>
      </div>
      <div class="modal_window" v-if="showChangePasswordModal">
        <changePasswordModalWindow
          :mode="mode"
          :targetId="adminUserId"
          :tenantKey="corporation.tenantKey"
          @close="stayClose"
          @change="change"
        >
        </changePasswordModalWindow>
      </div>
      <div class="modal_window" v-if="showDeleteConfirmModal">
        <deleteConfirmModalWindow @close="deleteClose()" @stayClose="stayClose">
        </deleteConfirmModalWindow>
      </div>
    </div>
  </div>
</template>

<script>
import contractEditInfo from './corporationComponents/contractEditInfo.vue'
import tenantEditInfo from './corporationComponents/tenantEditInfo.vue'
import tenantOptionEditInfo from './corporationComponents/tenantOptionEditInfo.vue'
import completeModalWindow from '../modalWindow/finishModalWindow.vue'
import loadingModalWindow from '../../../modalWindow/loadingModalWindow.vue'
import changePasswordModalWindow from '../modalWindow/changePasswordModalWindow.vue'
import deleteConfirmModalWindow from '../modalWindow/corporationDeleteModalWindow.vue'

export default {
  data() {
    return {
      contractEditInfoTitle: '契約情報',
      tenantEditInfoTitle: 'テナント情報',
      tenantOptionEditInfoTitle: 'テナントオプション',
      deleteButton: '削除',
      cancelButton: 'キャンセル',
      addButton: '完了',
      headerTitle: '編集',
      mode: 'adminAccount',
      completeWord: '',
      failureWord: '',
      showModal: false,
      showCompleteModal: false,
      showloadingModal: false,
      showFailureModal: false,
      showChangePasswordModal: false,
      showDeleteConfirmModal: false,
      contentsHeight: '',
      contentsBackgroundHeight: ''
    }
  },
  computed: {
    headerTitles() {
      return this.$store.state.masters.editHeaderTitle
    },
    adminUserId() {
      return this.$store.state.corporations.corporation.adminUsers[0]
        .adminUserId
    },
    sysErrorMsg() {
      return this.$store.state.error.sysErrorMsg
    },
    callAppList() {
      return this.$store.state.corporations.callAppDefine
    },
    corporation() {
      return this.$store.state.corporations.corporation
    }
  },
  created() {
    this.$store.dispatch('corporations/clearCorporation')
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
    this.updateWindowHeight()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  components: {
    tenantEditInfo,
    contractEditInfo,
    tenantOptionEditInfo,
    completeModalWindow,
    loadingModalWindow,
    changePasswordModalWindow,
    deleteConfirmModalWindow
  },
  methods: {
    handleResize() {
      // ウィンドウサイズ変更時にリアルタイムでウィンドウサイズの値を更新
      this.updateWindowHeight()
    },
    updateWindowHeight() {
      var contaractHeight = document.getElementById('contract_info')
        .clientHeight
      var tenantHeight = document.getElementById('tenant_info').clientHeight
      var tenantOptionHeight = document.getElementById('tenant_option_info')
        .clientHeight
      var maxHeight = contaractHeight
      if (maxHeight < tenantHeight) {
        maxHeight = tenantHeight
      }
      if (maxHeight < tenantOptionHeight) {
        maxHeight = tenantOptionHeight
      }
      var height = maxHeight
      var contentsPaddingHeight = 52
      var buttonHeight = 40
      this.contentsHeight = height + contentsPaddingHeight + buttonHeight + 'px'
      this.contentsBackgroundHeight = height + 'px'
    },
    pageLink(path) {
      this.$router.push(path)
    },
    close(e) {
      this.showModal = false
      this.showCompleteModal = false
      this.showFailureModal = false
      this.showChangePasswordModal = false
      this.showDeleteConfirmModal = false
      this.$router.push('/master/corporations/detail')
    },
    stayClose(e) {
      this.showModal = false
      this.showCompleteModal = false
      this.showFailureModal = false
      this.showChangePasswordModal = false
      this.showDeleteConfirmModal = false
    },
    deleteClose(e) {
      this.showModal = false
      this.showCompleteModal = false
      this.showFailureModal = false
      this.showChangePasswordModal = false
      this.showDeleteConfirmModal = false
      this.$router.push('/master/corporations')
    },
    async cancel(e) {
      this.showloadingModal = true
      try {
        await this.$store.dispatch(
          'corporations/setDetailCorporation',
          this.corporation.companyId
        )
        this.$router.push('/master/corporations/detail')
      } catch (error) {
        let eventNumber = this.$store.state.error.sysErrorCode
          .sysErrorCode_130003
        this.createErrorMessage(error, eventNumber, 'MSGCRD0046')
        this.showFailureModal = true
      }
      this.showloadingModal = false
    },
    async updateCorporation(e) {
      this.showloadingModal = true
      var locationInfoEnableFlag = document.getElementsByName(
        'location_info_enable'
      )[0].checked

      // var gpsEnableFlag = document.getElementsByName('gps_enable')[0].checked
      var gpsEnableFlag = false

      var mailTargetFlag = document.getElementsByName('mail_target')[0].checked

      var pushNotificationEnableFlag = document.getElementsByName(
        'pushNotification_enable'
      )[0].checked

      var spEnableFlag = document.getElementsByName('silentPush_enable')[0]
        .checked

      var contactsEnableFlag = document.getElementsByName('contacts_enable')[0]
        .checked

      var corporationFlags = {
        locationInfoEnableFlag: locationInfoEnableFlag,
        gpsEnableFlag: gpsEnableFlag,
        mailTargetFlag: mailTargetFlag,
        pushNotificationEnableFlag: pushNotificationEnableFlag,
        spEnableFlag: spEnableFlag,
        contactsEnableFlag: contactsEnableFlag
      }
      await this.$store.dispatch('corporations/setFlags', corporationFlags)

      var callAppList = []
      for (let i = 0; i < this.callAppList.length; i++) {
        var selector =
          'input[name="' + this.callAppList[i].id + '"].callAppCheckbox'
        if (document.querySelector(selector).checked) {
          callAppList.push({
            id: this.callAppList[i].id,
            callAppName: this.callAppList[i].callAppName,
            urlScheme: this.callAppList[i].urlScheme
          })
        }
      }
      await this.$store.dispatch('corporations/setCallAppList', callAppList)

      try {
        await this.$store.dispatch('corporations/updateCorporation')
        this.showModal = false
        this.completeWord = '変更しました。'
        this.showCompleteModal = true
      } catch (error) {
        let eventNumber = this.$store.state.error.sysErrorCode
          .sysErrorCode_130001
        this.createErrorMessage(error, eventNumber, 'MSGCRD0047')
        this.showFailureModal = true
        this.showloadingModal = false
        return
      }
      try {
        await this.$store.dispatch(
          'corporations/setDetailCorporation',
          this.corporation.companyId
        )
      } catch (error) {
        let eventNumber = this.$store.state.error.sysErrorCode
          .sysErrorCode_130003
        this.createErrorMessage(error, eventNumber, 'MSGCRD0046')
        this.showFailureModal = true
      }
      this.showloadingModal = false
    },
    createErrorMessage(error, eventNumber, errorNumber) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.header &&
        error.response.data.header.message
      ) {
        let errorMessage = error.response.data.header.message
        if (!errorMessage.indexOf('MSGCRD')) {
          this.failureWord =
            this.sysErrorMsg[errorMessage].name +
            this.sysErrorMsg[errorMessage].value +
            'エラーコード：{' +
            eventNumber +
            '}'
        } else {
          this.failureWord =
            this.sysErrorMsg[errorNumber].name +
            this.sysErrorMsg[errorNumber].value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
      } else {
        this.failureWord =
          this.sysErrorMsg.MSGCRD0001.name +
          this.sysErrorMsg.MSGCRD0001.value +
          'エラーコード：{' +
          eventNumber +
          '}'
      }
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/CorporationView/corporationEdit.vue